import { serializable, primitive } from 'serializr';

export class Size {
  @serializable(primitive())
  id?: number;

  @serializable(primitive())
  name?: string;
}
